export var AkamaiCookie = 'x-kbb-aka-data';